import React, { createContext, useContext, useState } from 'react';
import { useTheme } from './ThemeContext';
import i18n from '../I18n/config';

const AppLoadingContext = createContext();

export function AppLoadingProvider({ clientId, children }) {
  const { loading: themeLoading } = useTheme();
  const [i18nLoading, setI18nLoading] = useState(true);
  const [error, setError] = useState(null);

  // Verifica se o i18n já foi inicializado
  // O i18n é inicializado automaticamente quando o módulo é importado (I18n/config.js)
  React.useEffect(() => {
    // Aguarda a inicialização do i18n
    const checkI18nReady = () => {
      if (i18n.isInitialized) {
        setI18nLoading(false);
      } else {
        // Se ainda não inicializou, aguarda o evento
        i18n.on('initialized', () => {
          setI18nLoading(false);
        });
      }
    };

    checkI18nReady();
  }, []);

  const isLoading = themeLoading || i18nLoading;

  return (
    <AppLoadingContext.Provider value={{ isLoading, error }}>
      {children}
    </AppLoadingContext.Provider>
  );
}

export function useAppLoading() {
  return useContext(AppLoadingContext);
} 
